"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValueChecked = exports.isAttributeChecked = exports.getCheckedAttributeValuePair = exports.createCheckedItem = void 0;
const cuid_1 = __importDefault(require("cuid"));
const DELIMITER = (0, cuid_1.default)();
const createCheckedItem = ({ label, value }) => `${label}${value ? `${DELIMITER}${value}` : ''}`;
exports.createCheckedItem = createCheckedItem;
const getCheckedAttributeValuePair = (item) => item.split(DELIMITER);
exports.getCheckedAttributeValuePair = getCheckedAttributeValuePair;
const isAttributeChecked = (item) => (0, exports.getCheckedAttributeValuePair)(item).length === 1;
exports.isAttributeChecked = isAttributeChecked;
const isValueChecked = (item) => (0, exports.getCheckedAttributeValuePair)(item).length === 2;
exports.isValueChecked = isValueChecked;
